import { render, staticRenderFns } from "./DictPanel.vue?vue&type=template&id=6a67f755&scoped=true"
import script from "./DictPanel.vue?vue&type=script&lang=js"
export * from "./DictPanel.vue?vue&type=script&lang=js"
import style0 from "./DictPanel.vue?vue&type=style&index=0&id=6a67f755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67f755",
  null
  
)

export default component.exports